var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag-button",class:{ 'is-inverted': _vm.isInverted },style:({ '--tag-background-color': _vm.ColorItHelper.restructureColorcode(_vm.color), '--tag-hover-color': _vm.ColorItHelper.restructureColorcode(_vm.hoverColor) })},[_c('Title',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }